import { Alert } from 'antd';
import styled from 'styled-components';
import { PATTERN_DOT_GRID } from '@/assets/brand';
import { BRAND } from '@/constants/brand';

export const LoginPage = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
  background-color: ${BRAND.ink};
  background-image:
    radial-gradient(ellipse at 50% 30%, rgba(97, 97, 215, 0.18), transparent 60%),
    linear-gradient(${BRAND.ink}f2, ${BRAND.ink}f2),
    url(${PATTERN_DOT_GRID});
  background-size: cover;
  background-position: center top;
`;

export const LoginContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 380px;
  padding: 40px 32px;
  background: rgba(11, 23, 117, 0.55);
  border: 1px solid rgba(140, 140, 235, 0.45);
  border-radius: 12px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(6px);
`;

export const LoginLogo = styled.img`
  width: min(180px, 60vw);
  height: auto;
  display: block;
  object-fit: contain;
  margin-bottom: 28px;
`;

export const LoginSubtitle = styled.p`
  margin: 0 0 28px;
  /* Narrower than the card so the line breaks between the two domains
     rather than leaving "account" orphaned on its own line. */
  max-width: 30ch;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.78);
  text-align: center;
  line-height: 1.5;
  text-wrap: pretty;
`;

export const StyledAlert = styled(Alert)`
  margin-top: 20px;
  width: 100%;
  background: rgba(246, 109, 107, 0.12) !important;
  border: 1px solid rgba(246, 109, 107, 0.55) !important;

  .ant-alert-message {
    color: rgba(255, 255, 255, 0.9) !important;
  }
`;
